<template>
  <span v-html="result"></span>
</template>

<script>
export default {
  name: 'nt-decorate',
  props: {
    value: {
      default: ''
    },
    pattern: {
      default: ''
    },
    color: {
      type: String,
      default: '#9ddda9'
    }
  },
  watch: {
    pattern(value) {
      const val = value.toString()
      this.regex = new RegExp(val, 'gi')
      this.format()
    }
  },
  data() {
    return {
      regex: new RegExp(this.$props.pattern.toString(), 'gi'),
      text: this.$props.value,
      result: ''
    }
  },
  created() {
    this.format()
  },
  methods: {
    format() {
      const val = this.value.toString()
      const world = val.match(this.regex)

      if (!world) {
        this.result = val
        return
      }
      this.result = val.replace(this.regex, value => `<span style='color: ${this.color}'>${value}</span>`)
    }
  }
}
</script>
